module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"bookDemo":"Planifier une démo","b":"Pour créer un environnement pour votre entreprise, discutons ensemble en vidéoconférence.","c":"ou contactez-nous à"},"en":{"bookDemo":"Book a demo","b":"To create an environment for your company, let\u0027s make a quick video call.","c":"or contact us at"}}')
  delete Component.options._Ctor
}
